module.exports = __webpack_public_path__ + "static/media/icon-book-outline.0876d6a7.svg";